var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGridwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grid"
  }, /*#__PURE__*/React.createElement("g", {
    id: "element-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.72 0.438599H1.77C0.792456 0.438599 0 1.23105 0 2.2086V7.1586C0 8.13614 0.792456 8.9286 1.77 8.9286H6.72C7.69754 8.9286 8.49 8.13614 8.49 7.1586V2.2086C8.49 1.23105 7.69754 0.438599 6.72 0.438599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.72 0.438599H1.77C0.792456 0.438599 0 1.23105 0 2.2086V7.1586C0 8.13614 0.792456 8.9286 1.77 8.9286H6.72C7.69754 8.9286 8.49 8.13614 8.49 7.1586V2.2086C8.49 1.23105 7.69754 0.438599 6.72 0.438599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.72 12H1.77C0.792456 12 0 12.7925 0 13.77V18.72C0 19.6975 0.792456 20.49 1.77 20.49H6.72C7.69754 20.49 8.49 19.6975 8.49 18.72V13.77C8.49 12.7925 7.69754 12 6.72 12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.2298 0.438599H13.2798C12.3022 0.438599 11.5098 1.23105 11.5098 2.2086V7.1586C11.5098 8.13614 12.3022 8.9286 13.2798 8.9286H18.2298C19.2073 8.9286 19.9998 8.13614 19.9998 7.1586V2.2086C19.9998 1.23105 19.2073 0.438599 18.2298 0.438599Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18.22 11.9386H13.27C12.2925 11.9386 11.5 12.7311 11.5 13.7086V18.6586C11.5 19.6361 12.2925 20.4286 13.27 20.4286H18.22C19.1975 20.4286 19.99 19.6361 19.99 18.6586V13.7086C19.99 12.7311 19.1975 11.9386 18.22 11.9386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M6.72 11.9386H1.77C0.792456 11.9386 0 12.7311 0 13.7086V18.6586C0 19.6361 0.792456 20.4286 1.77 20.4286H6.72C7.69754 20.4286 8.49 19.6361 8.49 18.6586V13.7086C8.49 12.7311 7.69754 11.9386 6.72 11.9386Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridwhite);
export default __webpack_public_path__ + "static/media/grid white.18db52ffbffe8beb7ca4df8207c3d5cd.svg";
export { ForwardRef as ReactComponent };